<div class="demo-carousel"
  [style.height]="parentHeight">
  <app-carousel-slide
    [timings]="carouselSlideConfig.timings"
    [autoplay]="carouselSlideConfig.autoplay"
    [interval]="carouselSlideConfig.interval"
    [loop]="carouselSlideConfig.loop"
    [hideArrows]="carouselSlideConfig.hideArrows"
    [hideIndicators]="carouselSlideConfig.hideIndicators"
    [color]="carouselSlideConfig.color"
    [maxWidth]="carouselSlideConfig.maxWidth"
    [proportion]="carouselSlideConfig.proportion"
    [useKeyboard]="carouselSlideConfig.useKeyboard"
    [useMouseWheel]="carouselSlideConfig.useMouseWheel"
    [orientation]="carouselSlideConfig.orientation"
    [slides]="carouselSlideConfig.slides"
    [maintainAspectRatio]="carouselSlideConfig.maintainAspectRatio"
    [slideHeight]="carouselSlideConfig.slideHeight"
    (change)="onSlideChange($event)"
  >
    <app-carousel-slide-item
      #matCarouselSlide
      *ngFor="let slide of imageList; let i = index"
      [image]="slide"
      [overlayColor]="carouselSlideItemConfig.overlayColor"
      [hideOverlay]="carouselSlideItemConfig.hideOverlay"
      [imageSize]="carouselSlideItemConfig.imageSize"
    >
    </app-carousel-slide-item>
  </app-carousel-slide>
</div>
<div class="download-container" *ngIf="enableDownload">
  <div style="display: flex; justify-content: center; margin-top: 12px;">
    <button
      mat-stroked-button
      class="border-box b-s my-1 me-1"
      (click)="downloadImage(currentSlide)"
    >
      Descargar Imagen
    </button>
  </div>
</div>



